module.exports = "/static/assets/4228211bf21ef065de9c5ad5e19c3cd3.svg";